module.exports = __webpack_public_path__ + "img/user.9e809aa5.png";